<script setup>
import { onMounted, ref } from 'vue';

defineProps({
    modelValue: String,
});

defineEmits(['update:modelValue']);

const input = ref(null);

onMounted(() => {
    if (input.value.hasAttribute('autofocus')) {
        input.value.focus();
    }
});

defineExpose({ focus: () => input.value.focus() });
</script>

<template>
    <textarea
        ref="input"
        class=""
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
    ></textarea>
</template>

<style scoped>
textarea{
    border: 1px solid var(--bs-gray-900);
    border-radius: 0px;
    padding: 4px 12px;
}
textarea:focus, textarea:focus-visible, textarea:active{
    border: 1px solid var(--bs-gray-900);
    border-radius: 0px;
    box-shadow: none !important;
}
textarea::placeholder{
    color: rgb(129, 129, 129);
}
</style>